<template>
  <component :is="signUpFormComponent" :open="isOpen" @close="handleClose" />
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters, mapActions } from "vuex";
import addDays from "date-fns/addDays";
import isAfter from "date-fns/isAfter";
import isSameDay from "date-fns/isSameDay";
import parseISO from "date-fns/parseISO";
import { getFeatureToggles } from "@/helpers/featureToggles.js";
export default {
  name: "DataCollection",
  emits: ["follow-up"],
  data() {
    return {
      open: false,
      initialLoggedInValue: false,
      isFreshVisit: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
    ...mapGetters("app", ["dataCollectionDismissed"]),
    version() {
      const { dataCollectionVersion = 6 } = getFeatureToggles();
      return dataCollectionVersion;
    },
    signUpFormComponent() {
      return defineAsyncComponent({
        loader: () =>
          import(
            /* webpackChunkName: "[request]" */ `@/components/sign-up-forms/ModalSignUpV${this.version}.vue`
          ),
      });
    },
    isOpen: {
      get() {
        const commonCondition = !(this.dataCollectionDismissed || !this.open);

        if (this.version === "4") {
          return commonCondition;
        }

        return commonCondition && !this.initialLoggedInValue;
      },
      set(value) {
        this.open = value;
      },
    },
  },
  mounted() {
    setTimeout(() => {
      this.initialLoggedInValue = this.isLoggedIn;
      this.checkIfShouldOpen();
    }, 5 * 1000);
  },
  methods: {
    ...mapActions("app", ["setUserPreferences"]),
    ...mapActions("auth", ["establishShopifySession"]),
    async handleClose() {
      const followUp = this.isFreshVisit;
      this.isFreshVisit = false;
      const signedUpDuringPopup = !this.initialLoggedInValue && this.isLoggedIn;

      this.setUserPreferences({
        key: "dataCollectionDismissed",
        value: true,
      });

      if (signedUpDuringPopup) {
        await this.establishShopifySession();
      }

      if (followUp) {
        this.$emit("follow-up");
      }
    },
    checkIfShouldOpen() {
      const storedDate = localStorage.getItem("shopifyDataCollectionDate");
      const memberPopupSeen =
        localStorage.getItem("memberDiscountPopupDismissed") === "true";

      if (memberPopupSeen) {
        this.isFreshVisit = false;
        this.isOpen = false;
        return;
      }

      if (!storedDate) {
        this.isOpen = true;
        this.isFreshVisit =
          !this.dataCollectionDismissed &&
          !this.initialLoggedInValue &&
          !memberPopupSeen;
        return;
      }

      const parsedStoredDate = parseISO(storedDate);
      const currentDate = new Date();
      const oneDayAfterStoredDate = addDays(parsedStoredDate, 1);
      const isOneDayAfter =
        isAfter(currentDate, oneDayAfterStoredDate) ||
        isSameDay(currentDate, oneDayAfterStoredDate);

      this.isOpen = isOneDayAfter;
    },
  },
};
</script>
